export default __webpack_public_path__ + "static/media/loading.6a22600b.gif";